module.exports = __webpack_public_path__ + "static/media/icon- line.46dad382.png";